import React from 'react';
import { Container, Grid2, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brandTokens } from '../single-page/theme';

const Root = styled('section')(({ theme }) => ({
  backgroundColor: brandTokens.navy,
  color: '#ffffff',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  borderTop: '1px solid rgba(255,255,255,0.06)',
  borderBottom: '1px solid rgba(255,255,255,0.06)',
}));

const Column = styled(Grid2)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    borderRight: '1px solid rgba(255,255,255,0.1)',
    '&:last-of-type': {
      borderRight: 'none',
    },
  },
}));

const TopLine = styled(Typography)(({ theme }) => ({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
  fontSize: '0.875rem',
  lineHeight: 1.3,
  color: 'rgba(255, 255, 255, 0.85)',
  marginBottom: theme.spacing(0.5),
}));

const MetricLine = styled(Typography)(({ theme }) => ({
  fontFamily: 'GT Haptik, Raleway, sans-serif',
  fontWeight: 700,
  fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
  lineHeight: 1.1,
  letterSpacing: '-0.02em',
  color: '#ffffff',
  marginBottom: theme.spacing(1),
}));

const BottomLine = styled(Typography)(({ theme }) => ({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 600,
  fontSize: '0.75rem',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  lineHeight: 1.4,
  color: brandTokens.cyan,
}));

const metrics = [
  { top: '+ de', value: '50.000', bottom: 'vistorias realizadas' },
  { top: '+ de', value: '5 milhões', bottom: 'de itens verificados' },
  { top: 'Presente em mais de', value: '60 pontos', bottom: 'pelo Brasil' },
];

const SocialProof = () => {
  return (
    <Root>
      <Container maxWidth="lg">
        <Grid2 container spacing={4}>
          {metrics.map((m) => (
            <Column size={{ xs: 12, md: 4 }} key={m.value}>
              <TopLine>{m.top}</TopLine>
              <MetricLine>{m.value}</MetricLine>
              <BottomLine>{m.bottom}</BottomLine>
            </Column>
          ))}
        </Grid2>
      </Container>
    </Root>
  );
};

export default SocialProof;
